module.exports = __webpack_public_path__ + "static/img/陆旸1.4146d44.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lbtuimaj/陆旸1.jpg
// module id = 0NCf
// module chunks = 1